import { OpenAPI } from 'app/API';
import { request } from 'app/API/core/request';
import type { TCall } from 'app/queries/types/TCall';

export const createUpdateJobNoShowMutationFn = (call: TCall) => (variables: { jobId: string; noShow: boolean }) =>
  call(() =>
    request<void>(OpenAPI, {
      method: 'PATCH',
      url: '/api/admin/jobs/{jobId}/no-show',
      path: { jobId: variables.jobId },
      body: { noShow: variables.noShow },
      mediaType: 'application/json',
    }),
  );
